import {useState, useEffect} from "react";
import logo from "/src/logos/logo1.png";
import logo2 from "/src/logos/logo-white.png";
import {useLocation} from "react-router-dom";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<string>("home");
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const pathName = useLocation().pathname;

  useEffect(() => {
    setIsActive(pathName.slice(1) || "home");
  }, [pathName]);

  useEffect(() => {
    window.innerWidth <= 820 ? setIsMobile(true) : setIsMobile(false);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <div className="w-[91%] lg:w-[97%] mx-auto">
      <div className="bg-transparent lg:bg-white justify-between items-center flex h-[100px] w-full">
        <div>
          <a href="/">
            <img
              className="top-[0px] left-[0px] lg:h-[100px] lg:min-w-[280px] h-[56px] min-w-[159px]"
              alt=""
              src={pathName == "/" && isMobile ? logo2 : logo}
            />
          </a>
        </div>

        <div className="hidden xl:grid grid-cols-7 items-center space-x-2">
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/">
            Home
          </a>
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/tool">
            Map
          </a>
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/comparator">
            Comparator
          </a>
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/methodology">
            Methods
          </a>
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/team">
            Team
          </a>
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/news">
            News
          </a>
          <a
            className="cursor-pointer btn bg-valpeacock text-white rounded-xl hover:text-valmidnight text-[17px] leading-[100%] font-caption-1! text-center"
            href="/research">
            Publications
          </a>
        </div>

        <div className="xl:hidden">
          <button
            className="cursor-pointer p-4"
            onClick={() => setIsMenuOpen(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="10"
              viewBox="0 0 18 10"
              fill="none">
              <path
                d="M1 5H17M1 1H17M1 9H9"
                stroke="#2A424B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <div
        className={`xl:hidden fixed inset-0 z-[1001] bg-white flex flex-col overflow-y-auto transition-transform duration-500 ease-in-out ${isMenuOpen ? "translate-x-0" : "translate-x-full"}`}>
        <div className="flex justify-between min-h-[100px] w-[91%] mx-auto items-center border-b border-gray-200">
          <img className="h-[56px] w-[159px]" alt="EARTH HCM" src={logo} />
          <button
            className="cursor-pointer p-4"
            onClick={() => setIsMenuOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#2A424B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="flex flex-col h-full justify-between w-[85%] mx-auto">
          <nav className="flex flex-col">
            <a
              href="/"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "home" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              Home
            </a>
            <a
              href="/tool"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "tool" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              Map
            </a>
            <a
              href="/comparator"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "comparator" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              Comparator
            </a>
            <a
              href="/methodology"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "methodology" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              Method
            </a>
            <a
              href="/team"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "team" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              Team
            </a>
            <a
              href="/news"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "news" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              News
            </a>
            <a
              href="/research"
              className={`text-[40px] my-3 underline-offset-[5px] ${isActive == "research" ? "text-[#188593] underline font-bold" : "text-[#2A424B] font-semibold"}`}
              onClick={() => setIsMenuOpen(false)}>
              Publications
            </a>
          </nav>
          <div className="py-5 border-t border-gray-200">
            <a
              href="mailto:mbutzner@cytokinetics.com"
              className="flex items-center gap-2 text-[#2A424B] text-[16px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none">
                <path
                  d="M3.24897 16.2447C2.80224 16.2447 2.41995 16.0857 2.1021 15.7679C1.78425 15.45 1.62505 15.0675 1.62451 14.6202V4.87348C1.62451 4.42675 1.78371 4.04446 2.1021 3.72661C2.42049 3.40876 2.80278 3.24956 3.24897 3.24902H16.2446C16.6913 3.24902 17.0739 3.40822 17.3923 3.72661C17.7107 4.04501 17.8696 4.42729 17.8691 4.87348V14.6202C17.8691 15.0669 17.7101 15.4495 17.3923 15.7679C17.0744 16.0863 16.6919 16.2452 16.2446 16.2447H3.24897ZM16.2446 6.49793L10.1732 10.2951C10.1055 10.3357 10.0346 10.3663 9.9604 10.3869C9.88621 10.4075 9.81501 10.4175 9.74678 10.4169C9.67856 10.4164 9.60762 10.4064 9.53398 10.3869C9.46034 10.3674 9.38913 10.3368 9.32036 10.2951L3.24897 6.49793V14.6202H16.2446V6.49793ZM9.74678 8.93461L16.2446 4.87348H3.24897L9.74678 8.93461ZM3.24897 6.70099V5.50295V5.52326V5.51351V6.70099Z"
                  fill="#2A424B"
                />
              </svg>
              <span className="underline">mbutzner@cytokinetics.com</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
